module.exports = __webpack_public_path__ + "media/images/message-send-8b8f4722442652baa321705f1eb948b4.svg";